import script from "./FullVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullVideo.vue?vue&type=script&lang=ts&setup=true"

import "./FullVideo.vue?vue&type=style&index=0&id=26f8e71a&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f8e71a"]])

export default __exports__